import { Card, SkeletonCard } from "@endya-conformite/ui-kit";
import { ConformiteDeclarationActiviteIobspReadContent } from "@src/conformite/declarationActivite/read/ConformiteDeclarationActiviteIobspRead";
import { ControleQuinquennalTemplate } from "@src/controleQuinquennal/ControleQuinquenalTemplate";
import { useControleQuinquennalAdmin } from "@src/controleQuinquennal/admin/useControleQuinquennalAdmin";
import { useDeclarationActiviteAdmin } from "../useDeclarationActiviteAdmin";

export function DeclarationActiviteIobspAdminPage() {
  const { entreprise, controleQuinquennal, status, avancement } =
    useControleQuinquennalAdmin();

  const { iobsp, isLoading } = useDeclarationActiviteAdmin(
    entreprise?.siren,
    controleQuinquennal?.millesime
  );

  if (status !== "loaded" || !entreprise || !controleQuinquennal || isLoading) {
    return (
      <ControleQuinquennalTemplate title="Déclaration d'activité IOBSP">
        <SkeletonCard />
      </ControleQuinquennalTemplate>
    );
  }

  return (
    <ControleQuinquennalTemplate
      title="Déclaration d'activité IOBSP"
      backUrl={`/admin/controle-quinquennal/${entreprise.hubspotId}`}
      isValid={avancement[entreprise.siren].declarationActiviteIobsp === 100}
    >
      <Card>
        <ConformiteDeclarationActiviteIobspReadContent
          declarationActivite={iobsp || null}
        />
      </Card>
    </ControleQuinquennalTemplate>
  );
}
